import React from 'react';
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined';
import { colors } from '../theme';

function Fallback() {
  return (
    <div style={{ height: '100%' }}>
      <ReportProblemOutlinedIcon
        style={{
          height: '100%',
          width: '100%',
          fill: colors.purple,
          opacity: 0.3,
        }}
      />
    </div>
  );
}

export default Fallback;
